import React, { useState, useEffect } from 'react';
import Nav from './Nav';
import { Link, useLocation } from 'react-router-dom';
import SideMenu from './SideMenu';

function HeaderThree() {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    
    const handleLogoClick = (e) => {
        if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            window.history.pushState(null, null, '/');
        }
    };

    const handleContactClick = (e, sectionId) => {
        if (location.pathname === '/') {
            e.preventDefault();
            const element = document.getElementById(sectionId);
            if (element) {
                const headerHeight = 100;
                const elementPosition = element.offsetTop - headerHeight;
                
                window.scrollTo({
                    top: elementPosition,
                    behavior: 'smooth'
                });
                window.history.pushState(null, null, `#${sectionId}`);
            }
        }
    };
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div>
            <header className={`header-three header--sticky  ${isSticky ? 'sticky' : ''}`}>
                <div className="container">
                    <div className="row header-top-three">
                        <div className="col-lg-6">
                            <p className="top-left">
                                Izodrom Grup angajează, vezi pozitiile{" "}
                                <Link to="/careers" onClick={(e) => handleContactClick(e, 'careers')}>
                                    Locuri vacante <i className="far fa-arrow-right" />
                                </Link>
                            </p>
                        </div>
                        <div className="col-lg-6 right-h-three">
                            <div className="header-top-right">
                                <div className="single-right email">
                                    <i className="fas fa-envelope" />
                                    <Link to={'#'}>office@izodrom.md</Link>
                                </div>
                                <div className="single-right call">
                                    <i className="far fa-phone-volume" />
                                    <span>Telefon:</span>
                                    <Link to={'#'}>+373 268 25-763</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row main-header main-header-three">
                        <div className="col-lg-3 col-md-4 col-sm-5 col-5">
                            <Link to={'/'} className="thumbnail-logo" onClick={handleLogoClick}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images_new/logo.png`} alt="Logo_three" />
                            </Link>
                        </div>
                        <div className="col-lg-6 d-none d-xl-block">
                            <div className="text-center d-flex justify-content-center">
                                <Nav />
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-9 col-md-8 col-sm-7 col-7">
                            <div className="right justify-content-end">
                                <Link to={'/careers'} className="rts-btn btn-primary-3" onClick={(e) => handleContactClick(e, 'careers')}>
                                    Angajează-te!
                                </Link>
                                <button
                                    id="menu-btn"
                                    className="menu rts-btn btn-primary-3-menu ml--20" onClick={toggleSidebar}
                                >
                                    <img
                                        className="menu-dark"
                                        src={`${process.env.PUBLIC_URL}/assets/images/icon/menu.png`}
                                        alt="Menu-icon"
                                    />
                                    <img
                                        className="menu-light"
                                        src={`${process.env.PUBLIC_URL}/assets/images/icon/menu-light.png`}
                                        alt="Menu-icon"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <SideMenu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </div>
    )
}

export default HeaderThree